import { Grid, TextField, RadioGroup, FormControlLabel, Radio, Divider } from '@mui/material'
import Paragraph from '../../../../../../shared/UI/Paragraph'
import { RtwMaintenanceRequest } from '../../../../../../types/return-to-work'
import { boolToString, stringToBool } from '../../../../../../utils/rtwUtils'

type Props = {
  proceduresFollowed: boolean
  proceduresComments: string
  onFieldChange: (field: keyof RtwMaintenanceRequest, value: any) => void
}

function ProceduresSection({ proceduresFollowed, proceduresComments, onFieldChange }: Props) {
  return (
    <>
      <Grid item xs={12}>
        <Paragraph>Have all procedures been followed?</Paragraph>
        <RadioGroup
          row
          aria-labelledby="procedures-radio-group"
          name="procedures-radio-group"
          value={boolToString(proceduresFollowed)}
          onChange={(e, checked) => {
            onFieldChange('proceduresFollowed', stringToBool(checked))
          }}
        >
          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
          <FormControlLabel value="No" control={<Radio />} label="No" />
        </RadioGroup>
      </Grid>
      <Grid item xs={12} mt={2}>
        <TextField
          id="procedures-additional-comment"
          label="Additional comment"
          variant="outlined"
          value={proceduresComments}
          onChange={(e) => onFieldChange('proceduresComments', e.target.value)}
          fullWidth
          sx={{ paddingBottom: '8px' }}
        />
        <Divider sx={{ margin: '30px 0' }} />
      </Grid>
    </>
  )
}

export default ProceduresSection